import {NfMessage, NfMessageType} from "../NfMessage";
import {NfComponentGlobalMessage} from "../NfComponentGlobalMessage";
import type {InstanceConfiguration} from "../../../frontendClasses/InstanceConfiguration";


/**
 * Wiadomość, on elementu NfHotelBookingEngineModal z ustawioną w nim konfiguracją widgeta
 */
export class SetInstanceConfiguration extends NfComponentGlobalMessage {
    public persistentMessage = true;
    declare instanceConfiguration: any;

    public constructor(sourceComponentId: number | MessageEvent<SetInstanceConfiguration> | null, instanceConfiguration?: InstanceConfiguration) {
        super(NfMessageType.SetInstanceConfiguration, arguments.length > 1);
        if (NfMessage.isMessageEvent(sourceComponentId)) {
            Object.assign(this, sourceComponentId.data);
        } else {
            this.sourceComponentId = sourceComponentId;
            if (!instanceConfiguration) {
                throw Error('instanceConfiguration is required');
            }
            this.instanceConfiguration = this.serialize(instanceConfiguration);
        }
    }
    public getInstanceConfiguration(): InstanceConfiguration {
        return this.deserialize(this.instanceConfiguration);
    }

}
NfMessage.creationCallbacks[NfMessageType.SetInstanceConfiguration] = (event) => {
    return new SetInstanceConfiguration(event);
}
